import * as ApiRequest from "./components/Helper/ApiRequest";
import * as Area from "./components/Helper/Area";
import * as Calendar from "./components/Helper/Calendar";
import * as Contact from "./components/Helper/Contact";
import * as Cookie from "./components/Helper/Cookie";
import * as Dates from "./components/Helper/Dates";
import * as Directory from "./components/Helper/Directory";
import * as Map from "./components/Helper/Map";
import * as Styling from "./components/Helper/Styling";
import * as Url from "./components/Helper/Url";
import * as WaypointGuidance from "./components/Helper/WaypointGuidance";

const Helper = {
    ...ApiRequest,
    ...Area,
    ...Calendar,
    ...Contact,
    ...Cookie,
    ...Dates,
    ...Directory,
    ...Map,
    ...Styling,
    ...Url,
    ...WaypointGuidance,
};

export default Helper;
